export function IllustrationDefiImage({ className }: { className?: string }) {
  return (
    <img
      className={className}
      src="/images/atelier-qualite.webp"
      alt="Technicien nettoyant un smartphone reconditionné"
      loading="lazy"
      style={{ borderRadius: 'var(--radius-md)', objectFit: 'cover' }}
    />
  );
}
